package com.macrofocus.eflux.data

import com.macrofocus.common.units.Quantity
import org.molap.dataframe.rowmajor.RowMajorDataFrame
import kotlin.reflect.KClass

class BranchPowerFlowColumn(val name: String, override val type: KClass<*>, val value: (BranchPowerFlowRecord) -> Any?) : RowMajorDataFrame.Column<BranchPowerFlowRecord,Any?> {
    override fun getValue(row: BranchPowerFlowRecord): Any? {
        return value(row)
    }

    override fun toString(): String {
        return "$name"
    }

    companion object {
        val i = BranchPowerFlowColumn("i", String::class, { it.i })
        val j = BranchPowerFlowColumn("j", String::class, { it.j })
        val ckt = BranchPowerFlowColumn("ckt", String::class, { it.ckt })
        val r = BranchPowerFlowColumn("r", Quantity::class, { it.r })
        val x = BranchPowerFlowColumn("x", Quantity::class, { it.x })
        val b = BranchPowerFlowColumn("b", Quantity::class, { it.b })
        val ratea = BranchPowerFlowColumn("ratea", Quantity::class, { it.ratea })
        val rateb = BranchPowerFlowColumn("rateb", Quantity::class, { it.rateb })
        val ratec = BranchPowerFlowColumn("ratec", Quantity::class, { it.ratec })
        val gi = BranchPowerFlowColumn("gi", Quantity::class, { it.gi })
        val bi = BranchPowerFlowColumn("bi", Quantity::class, { it.bi })
        val gj = BranchPowerFlowColumn("gj", Quantity::class, { it.gj })
        val bj = BranchPowerFlowColumn("bj", Quantity::class, { it.bj })
        val st = BranchPowerFlowColumn("st", Int::class, { it.st })
        val met = BranchPowerFlowColumn("met", Int::class, { it.met })
        val len = BranchPowerFlowColumn("len", Double::class, { it.len })
        val o1 = BranchPowerFlowColumn("o1", Double::class, { it.o1 })
        val f1 = BranchPowerFlowColumn("f1", Double::class, { it.f1 })

        val all : Array<BranchPowerFlowColumn> = arrayOf(
            i, j, ckt, r, x, b, ratea, rateb, ratec, gi, bi, gj, bj, st, met, len, o1, f1,
            //                                BranchPowerFlowRawColumn("o2", Double::class, { it.o2 }),
            //                                BranchPowerFlowRawColumn("f2", Double::class, { it.f2 })
        )
        val meaningful : Array<BranchPowerFlowColumn> = arrayOf(
            ckt, r, x, b, ratea, rateb, ratec, gi, bi, gj, bj, st, met, len, o1, f1,
            //                                BranchPowerFlowRawColumn("o2", Double::class, { it.o2 }),
            //                                BranchPowerFlowRawColumn("f2", Double::class, { it.f2 })
        )

        val selected : Array<BranchPowerFlowColumn> = arrayOf(
            ckt, r, x, b
            //                                BranchPowerFlowRawColumn("o2", Double::class, { it.o2 }),
            //                                BranchPowerFlowRawColumn("f2", Double::class, { it.f2 })
        )
    }
}

